<template>
  <b-card
    no-body
  >

    <b-form>
      <b-row>

        <b-col
          sm="12"
          class="d-flex align-items-center mb-2"
        >
          <feather-icon
            icon="UserIcon"
            size="16"
          />
          <h5 class="mb-0 ml-75 font-weight-normal">
            {{ camperStudent(1) }} Info
          </h5>
        </b-col>

        <b-col sm="4">
          <b-form-group
            label="First Name"
          >
            <b-form-input
              v-model="userData.first_name"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Last Name"
          >
            <b-form-input
              v-model="userData.last_name"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Phone Number"
          >
            <b-form-input
              v-model="userData.phone"
            />
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group
            label="Gender"
          >
            <div
              class="d-flex"
            >
              <b-form-radio
                v-model="userData.extra_user_info.gender"
                name="some-radios"
                value="Male"
              >
                Male
              </b-form-radio>
              <b-form-radio
                v-model="userData.extra_user_info.gender"
                name="some-radios"
                value="Female"
                class="ml-2"
              >
                Female
              </b-form-radio>
            </div>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group
            label="Email"
          >
            <b-form-input
              v-model="userData.email"
            />
          </b-form-group>
        </b-col>

        <b-col
          sm="12"
          class="mt-1 d-flex align-items-center mb-2"
        >
          <feather-icon
            icon="MapPinIcon"
            size="16"
          />
          <h5 class="mb-0 ml-75 font-weight-normal">
            Address
          </h5>
        </b-col>

        <b-col sm="4">
          <b-form-group
            label="Address Line 1"
          >
            <b-form-input
              v-model="userData.address.address_line_1"
              placeholder="Address Line 1"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Address Line 2"
          >
            <b-form-input
              v-model="userData.address.address_line_2"
              placeholder="Address Line 2"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Postcode"
          >
            <b-form-input
              v-model="userData.address.zip"
              placeholder="Postcode"
            />
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group
            label="City"
          >
            <b-form-input
              v-model="userData.address.city"
              placeholder="City"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="State"
          >
            <b-form-input
              v-model="userData.address.state"
              placeholder="State"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group
            label="Country"
          >
            <b-form-input
              v-model="userData.address.country"
              placeholder="Country"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <div
            v-if="validationErrors.length"
            class="form-group pt-1"
          >
            <p
              v-for="(validationError, index) in validationErrors"
              :key="index"
              class="text-center text-danger"
            >
              {{ validationError }}
            </p>
          </div>
        </b-col>

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            :disabled="!$can('update', permissionSubjects.Child)"
            @click="handleForm"
          >
            Save changes
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-primary"
            type="reset"
            class="mt-2"
            :to="{ name: 'admin-students'}"
            @click.prevent="resetForm"
          >
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-form>

  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol,
  BButton, BForm, BFormGroup, BFormInput, BFormRadio,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { permissionSubjects } from '@/libs/acl/constants'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadio,
    BButton,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      permissionSubjects,
    }
  },
  methods: {
    handleForm() {
      this.$emit('updStudentInfo')
    },
  },
}
</script>

<style>

</style>
